import React from 'react';
import {Typography} from "@mui/material";
import BottomBorder from "../BottomBorder";
import {AiMentionsStepContent} from "../../models/AiMentionsContent";

interface StepperProps {
    // Exactly three - the content document enforces the count
    steps: AiMentionsStepContent[];
    closing: string;
}

const Stepper: React.FC<StepperProps> = ({steps, closing}) => (
    <section className="lnk-aim__steps">
        <div className="lnk-aim__title-block lnk-aim__title-block--center">
            <Typography variant="h2">איך זה עובד</Typography>
            <BottomBorder width={69} addMargin={false}/>
        </div>

        <div className="lnk-aim__steps-grid">
            <div className="lnk-aim__steps-line" aria-hidden="true"/>
            {steps.map((step, index) => (
                // Index, not the title: two steps may legitimately be renamed to
                // the same thing mid-edit and React must not collapse them.
                <div className="lnk-aim__step" key={index}>
                    <div className="lnk-aim__step-num" aria-hidden="true">{index + 1}</div>
                    <div className="lnk-aim__step-title">{step.title}</div>
                    <div className="lnk-aim__step-sub">{step.body}</div>
                </div>
            ))}
        </div>

        <p className="lnk-aim__steps-closing">{closing}</p>
    </section>
);

export default Stepper;
